import React from 'react';
import styled from 'styled-components';
import { Line, Text, Title } from '../../../../components';
import { COLORS, device } from '../../../../constants';

type DescriptionObj = {
  [key: string]: string;
};

interface DivProps extends React.HTMLProps<HTMLDivElement> {
  obj: DescriptionObj;
}

export const DescriptionElement: React.FC<DivProps> = ({ obj, ...props }) => {
  return (
    <ElementStyle {...props}>
      <Title
        size={24}
        lineHeight={36}
        weight={600}
        color={COLORS.BLACK}
        title={obj[Object.keys(obj)[0]]}
      />
      <Line width={400} color={COLORS.MAIN_RED} height={1} />
      <Text
        size={22}
        color={COLORS.BLACK}
        opacity={0.6}
        text={Object.keys(obj)[0].replaceAll('_', ' ')}
      />
    </ElementStyle>
  );
};

const ElementStyle = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  @media screen and (${device.xl}) {
    > div {
      width: 100%;
    }
  }
  @media screen and (${device.md}) {
    gap: 5px;
    > span {
      font-size: 18px;
      font-weight: 500;
    }
    > h4 {
      font-size: 16px;
    }
  }
  @media screen and (${device.sm}) {
    gap: 2px;
    > span {
      font-size: 11px;
    }
    > h4 {
      font-size: 13px;
    }
  }
`;
